import { forwardRef, type Ref } from "react";
import { MDSSelectMenu } from "@/mds/components/menu/select-menu/select-menu";
import { MDSMenuContentItemKind, MDSMenuContentList } from "@/mds/components/menu/menu.types";
import { MDSSelectMenuProps } from "@/mds/components/menu/select-menu/select-menu.types";
import { MDSSelectMenuItem } from "@/mds/components/menu/select-menu/select-menu-item";
import { MDSMenuItemHeader } from "@/mds/components/menu/menu-item-header/menu-item-header";
import { MDSMenuItemDivider } from "@/mds/components/menu/menu-item-divider";

interface MDSSelectMenuWithContentProps extends MDSSelectMenuProps {
  contentList: MDSMenuContentList;
  getItemRef?: ({ itemId }: { itemId: string }) => Ref<HTMLDivElement> | undefined;
}

export const MDSSelectMenuWithContent = forwardRef<HTMLDivElement, MDSSelectMenuWithContentProps>(
  ({ contentList, getItemRef, ...props }, ref) => {
    return (
      <MDSSelectMenu {...props} ref={ref}>
        {contentList.map(item => {
          if (item.kind === MDSMenuContentItemKind.Item) {
            return (
              <MDSSelectMenuItem
                key={item.id}
                {...item}
                itemRef={getItemRef?.({ itemId: item.id })}
              />
            );
          }
          if (item.kind === MDSMenuContentItemKind.Header) {
            return <MDSMenuItemHeader key={item.id} {...item} />;
          }
          if (item.kind === MDSMenuContentItemKind.Divider) {
            return <MDSMenuItemDivider key={item.id} />;
          }
        })}
      </MDSSelectMenu>
    );
  }
);

MDSSelectMenuWithContent.displayName = "MDSSelectMenuWithContent";
